var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCA43",
    d: "m19.145.38 4.387 14.142h14.194l-11.484 8.74 4.387 14.142-11.484-8.74-11.484 8.74 4.387-14.142-11.484-8.74h14.195z"
  })));
};
export { SvgStar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjE0NSAwLjM4MDEyN0wyMy41MzE1IDE0LjUyMkwzNy43MjYzIDE0LjUyMkwyNi4yNDI0IDIzLjI2MjFMMzAuNjI4OSAzNy40MDRMMTkuMTQ1IDI4LjY2MzlMNy42NjExIDM3LjQwNEwxMi4wNDc2IDIzLjI2MjFMMC41NjM2NiAxNC41MjJMMTQuNzU4NSAxNC41MjJMMTkuMTQ1IDAuMzgwMTI3WiIgZmlsbD0iI0ZGQ0E0MyIvPgo8L3N2Zz4K";